import { render } from "./ServiceTerms.vue?vue&type=template&id=3e884e01&scoped=true"
import script from "./ServiceTerms.vue?vue&type=script&lang=js"
export * from "./ServiceTerms.vue?vue&type=script&lang=js"

import "./ServiceTerms.vue?vue&type=style&index=0&id=3e884e01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e884e01"]])

export default __exports__